import { useState } from "react";
import { Send, Loader2 } from "lucide-react";

export function ChatInput({ loading, onSend }) {
  const [input, setInput] = useState("");
  const submit = (e) => {
    e.preventDefault();
    const text = input.trim();
    if (!text) return;
    setInput("");
    onSend(text);
  };
  return (
    <form onSubmit={submit} className="px-3 py-2.5 border-t border-[#2F4F4F]/20 bg-ib-surface flex-shrink-0">
      <div className="flex items-center gap-2">
        <input
          data-testid="chat-input"
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type your message..."
          disabled={loading}
          autoFocus
          className="flex-1 h-9 rounded-full bg-ib-bg border border-[#2F4F4F]/30 px-4 text-sm text-ib-text placeholder:text-[#71717A] font-manrope focus:outline-none focus:border-[#007BFF] transition-colors disabled:opacity-50"
        />
        <button type="submit" disabled={loading || !input.trim()} data-testid="chat-send-btn"
          className="w-9 h-9 rounded-full bg-[#007BFF] hover:bg-[#007BFF]/90 text-white flex items-center justify-center transition-colors disabled:opacity-40">
          {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />}
        </button>
      </div>
    </form>
  );
}
